module.exports = __webpack_public_path__ + "static/media/b7.c0cc7375.png";